import { Map } from "immutable";

export default {
  SET_STYLE(state, data) {
    state.style = data;
  },
  SET_VESSEL_CATEGORIES(state, data) {

    let id = data.id;

    if(id) {
      let categories = state.vessel_categories
      state.vessel_categories = categories.set(id, data.value);
    }
  },
  SET_ALL_VESSEL_CATEGORIES(state, value) {

    state.vessel_categories = Map({
      0: value, // 全て
      1: value,
      2: value,
      3: value,
      4: value,
      5: value,
      7: value,
      8: value,
      9: value,
      10: value,
      11: value,
    });
  },
  SET_PLOT_CATEGORIES(state, data) {

    let id = data.id;

    if(id) {
      let categories = state.plot_categories
      state.plot_categories = categories.set(id, data.value);
    }
  },
  SET_ALL_PLOT_CATEGORIES(state, value) {

    state.plot_categories =  Map({
      0: value, // 全て
      1: value,
      2: value,
      3: value,
      4: value,
      5: value,
      6: value,
      8: value,
      9: value,
      10: value,
      12: value,
      13: value,
      15: value,
      16: value,
    })
  },
  SET_CENTER(state, data) {
    state.center = {
      lat: data.lat,
      lng: data.lng
    }
  },
  SET_ZOOM(state, data) {
    state.zoom = data;
  },
  SET_DEFAULT_POSITION(state, data) {
    state.defaultPosition = data;
  }
}
